import { useEffect } from "react";
import { DadosContainerDefault } from "../../components/Styles";
import BancoTalentos from "../../components/BancoTalentos"
import Permissoes from "../../middleware/Permissoes";

function BancoTalento () {
  
  useEffect(()=>{
    document.title = "Banco de Talentos | Gesttor"
  },[])

  return (
    <DadosContainerDefault>
      <Permissoes permissoes={['master', 'consultor', 'recrutamento_banco_talentos']}>
        <BancoTalentos/>
      </Permissoes>
    </DadosContainerDefault>
  )
}

export default BancoTalento